<script lang="ts">
	import type { ComponentSectionsRedGreen, ComponentSharedFacts } from '$lib/graphql/strapiApi';
	import { Check, X } from 'lucide-svelte';
	import * as Card from '$lib/components/ui/card';
	import { cn } from '$lib/utils.js';

	let { content }: { content: ComponentSectionsRedGreen } = $props();
</script>

{#snippet redGreen(_class: string, section?: ComponentSharedFacts | null, check?: boolean)}
	{#if section}
		<Card.Root class={cn(_class, 'text-sm text-black max-sm:w-full')}>
			<Card.Header>
				<Card.Title class="flex items-center justify-center text-2xl"
					><h3>{section.title}</h3></Card.Title
				>
			</Card.Header>
			<Card.Content>
				{#if section.description}
					<Card.Description class="text-md h-[88px] font-medium text-primary"
						>{section.description}</Card.Description
					>
				{/if}
				<ul class="px-8 text-left max-sm:px-0">
					{#each section.facts ?? [] as fact}
						<li class="flex items-end gap-x-4 whitespace-nowrap py-2 max-sm:gap-x-1 sm:text-lg">
							{#if check}<Check class="stroke-green-700" />{:else}<X class="stroke-red-700" />{/if}
							{fact?.text}
						</li>{/each}
				</ul>
			</Card.Content>
		</Card.Root>
	{/if}
{/snippet}

<div class="flex w-full flex-col items-center text-center">
	<h1 class="mb-6 text-4xl font-bold">{content.title}</h1>
	<h2 class="mb-6 text-2xl font-bold">{content.description}</h2>
	<div class="flex flex-wrap justify-center gap-6">
		{@render redGreen('bg-red-100', content.red, false)}
		{@render redGreen('bg-green-100', content.green, true)}
	</div>
</div>
